/**
 * Devuelve las props que bloquean espacios al tipear.
 * No reemplaza validaciones necesarias.
 */
export function getNoSpaceInputProps(): React.InputHTMLAttributes<HTMLInputElement> {
  return {
    onKeyPress: (e) => {
      if (e.key === ' ') {
        e.preventDefault();
      }
    },
  };
}
